import React from "react";
import InlineGroupProfilesLinkingDropdown from "./InlineGroupProfilesLinkingDropdown";
import GQLUtil from "../../../global/utils/gqlHelper";
import PrefillUtil from "../../../global/utils/prefillHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";
import MappingResolver from "../../../data/schema/profiles/mappingResolver";
/**
 * requires the following props: schema, type, groupType, formName, formSection, groupLabel
 */
class InlineGroupPrefillerInput extends React.Component {
  constructor() {
    super();
    this.state = {
      index: -1,
      groupIndex: -1,
      groupSelected: "-Select-",
      selected: "-Select-",
    };
    this.selectProfile = this.selectProfile.bind(this);
    this.getProfiles = this.getProfiles.bind(this);
    this.findProfiles = this.findProfiles.bind(this);
    this.resetDropDowns = this.resetDropDowns.bind(this);
    this.prefill = this.prefill.bind(this);
    this.profiles = [];
    this.profilesGroups = [];
    this.staticProfiles = [];
  }

  componentDidUpdate(prevProps) {
    if (this.props.schema !== prevProps.schema) {
      this.setState({
        index: -1,
        groupIndex: -1,
      });
    }

    let filtered_profiles;
    if (this.props.profiles !== prevProps.profiles) {
      filtered_profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });

      this.setState({
        staticProfiles: filtered_profiles,
        profiles: filtered_profiles,
      });
    }
  }

  componentDidMount() {
    let profiles;
    let staticProfiles;
    let profilesGroups;

    if (this.props.schemaProps.prefill) {
      //get profiles
      profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });
      //gets profiles for dropdown
      staticProfiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });
      //gets profile groups
      profilesGroups = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.groupType;
      });

      this.setState({ profiles });
      this.setState({ profilesGroups });
      this.setState({ staticProfiles });
    }
  }

  //sets index and value of selected dropdown
  selectProfile(value, dropdown) {
    let id;
    let index;
    if (dropdown == "select") {
      id = "groupSelected";
      index = "groupIndex";
    } else if (dropdown == "select2") {
      id = "selected";
      index = "index";
    }
    if (value === "-Select-") {
      this.setState({
        [index]: value,
        [id]: value,
      });
    } else {
      this.setState({
        [index]: value,
        [id]: this.state.profiles[value],
      });
    }
  }

  //updates profiles
  findProfiles(newProfiles) {
    this.setState({
      profiles: newProfiles,
    });
  }

  //gets profiles associated with group
  getProfiles(name, type, staticProfiles, profilesGroups, selectProfile) {
    if (name == "-Select-") return false;
    if (type == "foreign-worker") {
      let filteredFWs = [];

      const ids = profilesGroups.filter((profile) => {
        if (name.trim() === profile?.name?.trim()) {
          return profile;
        }
      });
      let fwIDs = ids[0]?.fw_profiles;
      if (fwIDs) {
        for (const e of staticProfiles) {
          for (const x of fwIDs) {
            if (x == e.id) {
              filteredFWs.push(e);
            }
          }
        }
      }
      if (filteredFWs.length == 0) {
        selectProfile("-Select-", "select2");
      }
      this.findProfiles(filteredFWs);
    }
  }

  resetDropDowns(
    resetGroup,
    resetFWs,
    findProfiles,
    selectProfile,
    staticProfiles
  ) {
    findProfiles(staticProfiles);
    resetFWs.value = "-Select-";
    resetGroup.value = "-Select-";
    selectProfile("-Select-", "select2");
  }

  async prefill() {
    let formApi = this.props.formApi;
    //gets the query
    const query = ViewEntityQueryResolver(
      this.state.selected.type,
      this.state.selected.id
    );
    //runs query
    const data = await GQLUtil.genericGQLQuery(query);
    const dataKeys = PrefillUtil.dataResolver(this.state.selected.type);
    let rawData = data.data[dataKeys.query][dataKeys.formDataName];
    //get the mappings
    const mapping = PrefillUtil.getPrefillSchemaMapping(
      this.state.selected.type,
      this.props.schemaProps.prefill.formName,
      this.props.schemaProps.prefill.formSection
    );

    const mappingSchema = MappingResolver(mapping);

    formApi.batch(() => {
      //adds values to form fields
      mappingSchema.fields.forEach((field) => {
        let value = rawData[field.profileFieldName];
        let targetField = field.formTargetField;
        formApi.change(targetField, value);
      });
    });
  }

  render() {
    return (
      <div>
        <InlineGroupProfilesLinkingDropdown
          profiles={this.state.profiles}
          selectProfile={this.selectProfile}
          prefill={this.prefill}
          groupSelected={this.state.groupSelected}
          selected={this.state.selected}
          label={this.props.schemaProps.prefillLabel}
          groupLabel={this.props.schemaProps.groupPrefillLabel}
          key={this.props.schemaProps.prefillLabel}
          index={this.state.index}
          groupIndex={this.state.index2}
          profilesGroups={this.state.profilesGroups}
          findProfiles={this.findProfiles}
          type={this.props.schemaProps.prefill.type}
          staticProfiles={this.state.staticProfiles}
          getProfiles={this.getProfiles}
          resetDropDowns={this.resetDropDowns}
        />
      </div>
    );
  }
}

export default InlineGroupPrefillerInput;
